module.exports = __webpack_public_path__ + "static/media/innov.27179013.jpg";